<script>
import Constant from "@/constants/sections";
var CryptoJS = require("crypto-js");
export default {
  data() {
    return {
      roles: [],
      rol_section: null, //Si el componente se usa como hijo (ej: un tab), define de que modulo toma los permisos en vez del path de la ruta
      list_access: false,
      create_access: false,
      update_access: false,
      delete_access: false,
      sensible_access: false,
      sidebar_access: false,
    };
  },
  mounted() {
    this.getAccessArray();
  },
  methods: {
    getAccessArray() {
      //Si "access" falta o esta corrupto, el throw cortaba el flush de hooks `mounted` de vue
      //(se ejecutan en un mismo job, sin aislamiento de errores) y el mounted del propio
      //componente nunca corria: el Sidebar quedaba sin items y sin ningun aviso.
      try {
        this.roles = JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem("access"), Constant.SECRET_PHRASE).toString(CryptoJS.enc.Utf8));
      } catch (e) {
        console.error("No se pudieron leer los permisos del usuario", e);
        this.roles = {};
      }

      //var path = this.$route.path.replace("/", "");
      var path = this.rol_section != null ? this.rol_section : this.$route.path.split("/")[1].split("/")[0]; //Solo trae el primer key para determinar el modulo ex: /signatories/powers/1 -> signatories

      if (path in this.roles) {
        this.list_access = this.roles[path].list;
        this.create_access = this.roles[path].create;
        this.update_access = this.roles[path].update;
        this.delete_access = this.roles[path].delete;
        this.sensible_access = this.roles[path].sensible;
        this.sidebar_access = this.roles[path].sidebar;
      }
    },
  },
};
</script>
